<template>
  <div class="dialog-wrap">
    <el-dialog
      title="选题规划"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="678px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="选题名称"
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入选题名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="账号类型"
          prop="account_type_code"
        >
          <el-select
            v-model="dataForm.account_type_code"
            placeholder="请选择账号类型"
            style="width:360px;"
            @change="account_type_codeChange"
            clearable
          >
            <el-option
              label="机构"
              :value="1"
            ></el-option>
            <el-option
              label="课程"
              :value="2"
            ></el-option>
            <el-option
              label="学科"
              :value="3"
            ></el-option>
            <el-option
              label="院校"
              :value="4"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发布账号"
          prop="arr_account_id"
        >
          <el-link
            type="primary"
            :underline="false"
            @click="accountChooseDialog=true"
            :disabled="!dataForm.account_type_code"
          >选择账号</el-link>
          <div class="tags-wrap">
            <el-tag
              :key="index"
              v-for="(item,index) in accounts"
              closable
              :disable-transitions="false"
              @close="handleTagRemove(item)"
            >
              {{item.name}}/{{formatePlatform_code(item.platform_code)}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>

      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <AccountChoose
      :visible="accountChooseDialog"
      :content="accounts"
      @close="accountChooseDialog = false"
      @submit="saveAccounts"
      :type_codes="dataForm.account_type_code"
    ></AccountChoose>
  </div>
</template>

<script>


import { mediatopicCreate } from "@/api/select";
import AccountChoose from "@/components/dialog/select/AccountChoose"
export default {
  components: {
    AccountChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {

      },
      rules: {
        name: [{ required: true, message: '请输入选题名称', trigger: 'blur' }],
        account_type_code: [{ required: true, message: '请选择账号类型', trigger: 'blur' }],

        arr_account_id: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.accounts.length) {
              callback(new Error('请选择发布账号'))
            } else {
              callback()
            }
          },
        }],
      },
      accountChooseDialog: false,
      accounts: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {

    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            name: this.dataForm.name,
            arr_account_id: this.accounts.map(v => { return v.id }),
            remark: this.dataForm.remark,
            account_type_code: this.dataForm.account_type_code,
          }
          mediatopicCreate(query).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$emit('close')
    },
    saveAccounts(data) {
      this.accounts = data
    },
    handleTagRemove(item) {
      this.accounts = this.accounts.filter((v) => v.id !== item.id);
    },
    formatePlatform_code(val) {
      const platform_code = {
        1: "小红书",
        2: "公众号",
        3: "微博",
        /*   4: "B站", */
        5: "知乎",
        /*     6: "抖音", */
      };
      return platform_code[val] || "";
    },
    account_type_codeChange() {
      this.accounts = []
    }

  }
}
</script>

<style lang="less" scoped>
.tags-wrap {
  .el-tag {
    margin: 4px;
  }
}
</style>
